export default __webpack_public_path__ + "static/media/NRE_Powered_logo.90684478.png";